import cx from 'classnames';
import type { BlockViewProps } from '@plone/types';
import config from '@plone/registry';

import styles from './styles.module.css';
import type { BowlingCenterCarouselData } from './schema';
import type { BowlingCenterContent } from '../BowlingCenterDescription/schema';
import Body from './Body';

export type BowlingCenterCarouselViewProps = BlockViewProps & {
  data: BowlingCenterCarouselData;
  content: BowlingCenterContent;
};

const View = (props: BowlingCenterCarouselViewProps) => {
  const { className, style, data } = props;

  const Container = config.getComponent('Container').component || 'div';

  return (
    <section
      className={cx('block-bowlingcenter-carousel', styles.block, className)}
      style={style}
    >
      {!data?.styles.fullwidth ? (
        <Container
          className={cx('block-imagegallery-container', styles.container)}
        >
          <Body data={data} {...props} />
        </Container>
      ) : (
        <div className="block-bowlingcenter-carousel">
          <Body data={data} {...props} />
        </div>
      )}
    </section>
  );
};

export default View;
